module.exports = __webpack_public_path__ + "img/x3.57583ba2.jpg";